import { NgModule } from '@angular/core';

import {CommonModule} from '@angular/common';
import {CommonModuleP8} from '@Common/common-p8.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {MatAngularModule} from '@Common/mat-angular.module';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import {RouterModule} from '@angular/router';
import {
  ModaleContainerDossierComponent
} from "app/dar/dossier/consultation/modale-container/modale-container-dossier.component";
import {ButtonTransitionComponent} from "app/dar/dossier/button-transition/button-transition.component";
import {SectionDipefasComponent} from "app/dar/dossier/consultation/section-dipefas/section-dipefas.component";
import {
  ValidationButtonComponent
} from "app/dar/dossier/button-transition/validation-button/validation-button.component";
import {FilePreviewModaleComponent} from "app/dar/common/file-preview-modale/file-preview-modale.component";
import {
  PieceJointeUploadComponent
} from "app/dar/common/piece-jointe-uploader/piece-jointe-upload/piece-jointe-upload.component";
import {CommentsComponent} from "app/dar/dossier/comments/comments.component";
import {EditComponent} from "app/dar/dossier/comments/comment/edit/edit.component";
import {CommentComponent} from "app/dar/dossier/comments/comment/comment.component";
import {ConsultationComponent} from "app/dar/dossier/consultation/consultation.component";
import {CommonDarModule} from "app/dar/common/common.module";
import {AvisDrhComponent} from "app/dar/dossier/common/avis-drh/avis-drh.component";
import {AvisMsComponent} from "app/dar/dossier/common/avis-ms/avis-ms.component";
import {AvisSbtcpComponent} from "app/dar/dossier/common/avis-sbtcp/avis-sbtcp.component";
import {FormMsSbtcpComponent} from "app/dar/dossier/common/form-ms-sbtcp/form-ms-sbtcp.component";
import {ObsCommissionComponent} from "app/dar/dossier/common/obs-commission/obs-commission.component";
import {PeriodeCommissionComponent} from "app/dar/dossier/common/periode-commission/periode-commission.component";
import {PjDossierComponent} from "app/dar/dossier/common/pj-dossier/pj-dossier.component";
import {EditStepperComponent} from "app/dar/dossier/edit-stepper/edit-stepper.component";
import {
  EditStepperContentComponent
} from "app/dar/dossier/edit-stepper/edit-stepper-content/edit-stepper-content.component";
import {ListDossiersComponent} from "app/dar/dossier/list-dossiers/list-dossiers.component";
import {RecruteComponent} from "app/dar/dossier/common/recrute/recrute.component";
import { ContactsComponent } from './common/contacts/contacts.component';
import { DemandeurComponent } from './common/demandeur/demandeur.component';
import { FilterListDarComponent } from './list-dossiers/filter-list-dar/filter-list-dar.component';
import { ObservationsHistoriqueComponent } from './common/observations-historique/observations-historique.component';

@NgModule({
    imports: [
        CommonModule,
        CommonModuleP8,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        MatAngularModule,
        ReactiveFormsModule,
        MatGridListModule,
        MatInputModule,
        MatFormFieldModule,
        RouterModule,
        CommonDarModule,
    ],
    declarations: [
        ConsultationComponent,
        ModaleContainerDossierComponent,
        ButtonTransitionComponent,
        ValidationButtonComponent,
        PieceJointeUploadComponent,
        SectionDipefasComponent,
        CommentsComponent,
        CommentComponent,
        EditComponent,
        AvisDrhComponent,
        AvisMsComponent,
        AvisSbtcpComponent,
        FormMsSbtcpComponent,
        ObsCommissionComponent,
        PeriodeCommissionComponent,
        PjDossierComponent,
        EditStepperComponent,
        EditStepperContentComponent,
        ListDossiersComponent,
        RecruteComponent,
        ContactsComponent,
        DemandeurComponent,
        FilterListDarComponent,
        ObservationsHistoriqueComponent,
    ],
    exports: [
        ConsultationComponent,
        ModaleContainerDossierComponent,
        ButtonTransitionComponent,
        PieceJointeUploadComponent,
        SectionDipefasComponent,
        CommentsComponent,
        AvisDrhComponent,
        AvisMsComponent,
        AvisSbtcpComponent,
        FormMsSbtcpComponent,
        ObsCommissionComponent,
        PeriodeCommissionComponent,
        PjDossierComponent,
        EditStepperContentComponent,
    ]
})
export class DossierModule { }
